<div class="container mt-4">
    <div class="row text-center" style="">
        <div class="container mt-4">
            <img src="../../../../assets/images/icon-load-claro.svg" type="img/svg" class="p-2" alt="">
        </div>
        <!-- <div class="container">

        </div> -->
        <div id="loader"></div>
    </div>
    <div class="row">
        <div class="col-12">
            <br><br>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center">
            <span class="text-load">Tu pago est&aacute; siendo procesado</span>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center">

        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center">
            <span class="pls-wait">Por favor, espera</span>
        </div>
    </div>
</div>